import { MenuItem, MenuVariant, Promos } from '../../data/models';
import { QrOrderItem } from '../../data/table.types';

export interface ItemPriceView {
  price: number;
  oldPrice: number | null;
  percent: number;
  upTo: boolean;
}

export function promoPercent(promos: Promos, item: MenuItem, variant?: MenuVariant): number {
  return (
    promos.defaultPercent ??
    (variant ? promos.byId.get(String(variant.id)) : undefined) ??
    promos.byId.get(String(item.id)) ??
    0
  );
}

export function discounted(price: number, percent: number): number {
  return percent > 0 ? Math.round((price * (100 - percent)) / 100) : price;
}

/** Сумма позиции счёта или её добавки со скидкой позиции; null — скидки нет или тип не процентный. */
export function orderDiscounted(
  item: Pick<QrOrderItem, 'discount' | 'discountType'>,
  amount: number,
): number | null {
  if (item.discountType !== 'PERCENTAGE' || !(item.discount <= 100)) return null;
  const price = discounted(amount, item.discount);
  return price < amount ? price : null;
}

/** Скидка «действует», только если после округления цена реально стала меньше. */
export function itemPriceView(item: MenuItem, promos: Promos): ItemPriceView {
  const rows =
    item.variants.length > 0
      ? item.variants.map((v) => ({ base: v.price, percent: promoPercent(promos, item, v) }))
      : [{ base: item.price, percent: promoPercent(promos, item) }];
  const priced = rows.map(({ base, percent }) => {
    const price = discounted(base, percent);
    return { base, price, percent: price < base ? percent : 0 };
  });
  const price = Math.min(...priced.map((r) => r.price));
  const base = Math.min(...priced.map((r) => r.base));
  const percent = Math.max(...priced.map((r) => r.percent));
  return {
    price,
    oldPrice: price < base ? base : null,
    percent,
    upTo: percent > 0 && priced.some((r) => r.percent !== percent),
  };
}
